module.exports = __webpack_public_path__ + "img/XTZ-USD.1533fe82.png";